import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { NSPP_INFORMED_CONSENT } from '../../../../../../../services/i18n/namespaces';
import { generateUrlByKey, useCurrentRoute } from '../../../../../../root/router';

import './InformedConsentWidget.scss';

export const InformedConsentWidget = () => {
  const { t } = useTranslation(NSPP_INFORMED_CONSENT);
  const currentRoute = useCurrentRoute();

  return (
    <div className="eds-icf-widget">
      <div className="icfw-header">{t('informedConsent')}</div>
      <div className="icfw-item">
        <Link
          className={'icf-completed-link'}
          to={generateUrlByKey(`${currentRoute?.key}.Completed Informed Consents`, {
            patientId: currentRoute.params.patientId,
            ssuPatientId: currentRoute.params.ssuPatientId
          })}
        >
          {t('completedInformedConsents')}
        </Link>
      </div>
    </div>
  );
};
